import { PlotLibreError } from "./errors.js";
/**
 * Stable, path-aware PlotJSON failure surface.
 *
 * Context deliberately contains identifiers and scalar diagnostics only. It
 * must never retain the complete untrusted document or application metadata.
 */
export class PlotJsonError extends PlotLibreError {
    path;
    featureId;
    plotType;
    sourceVersion;
    targetVersion;
    limitName;
    limit;
    actual;
    cause;
    constructor(code, message, context = {}) {
        super(code, message);
        this.name = "PlotJsonError";
        this.path = context.path;
        this.featureId = context.featureId;
        this.plotType = context.plotType;
        this.sourceVersion = context.sourceVersion;
        this.targetVersion = context.targetVersion;
        this.limitName = context.limitName;
        this.limit = context.limit;
        this.actual = context.actual;
        this.cause = context.cause;
    }
}
//# sourceMappingURL=plotjson-error.js.map